"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
const react_1 = __importStar(require("react"));
const featureFlags_1 = require("../featureFlags");
exports.FileInput = (0, react_1.forwardRef)((props, ref) => {
    const { id, className, children, onChange, setFile, isMockTest, ...rest } = props;
    const handleChange = (event) => {
        const file = event.target.files?.[0];
        setFile && setFile(file);
        if (file && rest?.accept) {
            const fileExtension = file.name.split('.').pop()?.toLowerCase();
            const fileType = file.type;
            switch (rest.accept) {
                case 'image/*':
                    if (!['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
                        if (isMockTest) {
                            alert('모의고사 모드에서는 배경 이미지만 업로드 가능합니다.');
                        }
                        else {
                            alert('이미지 파일만 업로드 가능합니다.');
                        }
                        event.target.value = ''; // Clear the input
                        return;
                    }
                    break;
                case 'application/pdf':
                    if (fileExtension !== 'pdf') {
                        alert('PDF 파일만 업로드 가능합니다.');
                        event.target.value = ''; // Clear the input
                        return;
                    }
                    break;
                case 'video/*':
                    if (!['mp4', 'avi', 'mkv', 'mov', 'webm'].includes(fileExtension)) {
                        alert('비디오 파일만 업로드 가능합니다.');
                        event.target.value = ''; // Clear the input
                        return;
                    }
                    break;
                case 'image/*,application/pdf,video/*':
                case 'image/*,application/pdf,video/*,.zip,application/zip':
                    if (![
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'bmp',
                        'pdf',
                        'mp4',
                        'avi',
                        'mkv',
                        'mov',
                        'webm',
                        'zip',
                    ].includes(fileExtension)) {
                        alert('이미지, 비디오, PDF 또는 ZIP 파일만 업로드 가능합니다.');
                        event.target.value = ''; // Clear the input
                        return;
                    }
                    break;
                case 'excel':
                    if (!['xlsx', 'xls', 'csv'].includes(fileExtension)) {
                        alert('엑셀 파일만 업로드 가능합니다.');
                        event.target.value = ''; // Clear the input
                        return;
                    }
                    break;
                default:
                    if (![
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'bmp',
                        'pdf',
                        'xlsx',
                        'xls',
                        'csv',
                        'ppt',
                        'pptx',
                        'doc',
                        'docx',
                        'txt',
                        'mp4',
                        // B2: mp3 업로드 — MP3_FEATURE_ENABLED 로 게이트(비활성 시 미허용)
                        ...(featureFlags_1.MP3_FEATURE_ENABLED ? ['mp3'] : []),
                        'zip',
                    ].includes(fileExtension) &&
                        ![
                            'application/vnd.ms-excel',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'application/vnd.ms-powerpoint',
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                            'application/msword',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            'application/pdf',
                            'text/plain',
                            'video/mp4',
                            ...(featureFlags_1.MP3_FEATURE_ENABLED ? ['audio/mpeg', 'audio/mp3'] : []),
                            'application/zip',
                            'application/x-zip-compressed',
                        ].includes(fileType)) {
                        alert('허용된 파일 형식만 업로드 가능합니다.');
                        event.target.value = ''; // Clear the input
                        return;
                    }
            }
        }
        if (onChange) {
            onChange(event);
        }
    };
    return (react_1.default.createElement("label", { className: className, htmlFor: id, style: { cursor: 'pointer' } },
        react_1.default.createElement("input", { id: id, type: "file", style: { display: 'none' }, ref: ref, onChange: handleChange, ...rest }),
        children));
});
